import {ChartOption} from './Data/chart-option';

export class ChartBuilderBase {
  protected locale: string;


  constructor(locale: string) {
    this.locale = locale;
  }

  /**
   * Set language constants
   */
  // tslint:disable-next-line:ban-types
  protected setLanguage(chartOptions: Object): void {
    // this.setOption(chartOptions, 'lang', ChartOption.create('cst_language', 's', this.locale));
    switch (this.locale) {
      case 'it':
        this.setOption(chartOptions, 'lang', ChartOption.create('thousandsSep', 's', '.'));
        this.setOption(chartOptions, 'lang', ChartOption.create('decimalPoint', 's', ','));
        // tslint:disable-next-line:max-line-length
        this.setOption(chartOptions, 'lang', ChartOption.createArray('weekdays', ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato']));
        // tslint:disable-next-line:max-line-length
        this.setOption(chartOptions, 'lang', ChartOption.createArray('months', ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre']));
        // tslint:disable-next-line:max-line-length
        this.setOption(chartOptions, 'lang', ChartOption.createArray('shortMonths', ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic']));
        break;

      case 'de':
        this.setOption(chartOptions, 'lang', ChartOption.create('thousandsSep', 's', '.'));
        this.setOption(chartOptions, 'lang', ChartOption.create('decimalPoint', 's', ','));
        // tslint:disable-next-line:max-line-length
        this.setOption(chartOptions, 'lang', ChartOption.createArray('weekdays', ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']));
        // tslint:disable-next-line:max-line-length
        this.setOption(chartOptions, 'lang', ChartOption.createArray('months', ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']));
        // tslint:disable-next-line:max-line-length
        this.setOption(chartOptions, 'lang', ChartOption.createArray('shortMonths', ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']));
        break;

      case 'en':
      default:
    }
  }
// tslint:disable-next-line:ban-types no-shadowed-variable
  protected setOption(dst: Object, root: string, option: ChartOption): void {
    // if (dst[root] === undefined) {
    //     dst[root] = {};
    // }

    option.setOption(dst, root);
  }
}
